module.exports = __webpack_public_path__ + "img/huodng11.2176d28c.png";